/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_DoneInputs */

const cs_client_merge_done = /** @type {(inputs: Client_Merge_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti sloučeni`)
};

const en_client_merge_done = /** @type {(inputs: Client_Merge_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients merged`)
};

/**
* | output |
* | --- |
* | "Clients merged" |
*
* @param {Client_Merge_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_done = /** @type {((inputs?: Client_Merge_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_done(inputs)
	return cs_client_merge_done(inputs)
});